<template>
  <RevButtonBase
    class="relative block text-onaction-default-mid hover:bg-action-default-mid-hover bg-action-default-mid rounded-full border-1 border-transparent outline-2 outline-offset-4 focus-visible:outline-default-hi motion-safe:transition motion-safe:duration-[225ms] label-large h-40 px-16 disabled:bg-action-default-mid-disabled disabled:text-onaction-default-mid-disabled disabled:outline-none"
  >
    <div class="flex items-center gap-4 h-full">
      <component :is="icon" v-if="icon" class="shrink-0" />
      <span class="px-2 text-nowrap">{{ label }}</span>
    </div>
  </RevButtonBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconProductCollection } from '@ds/icons/IconProductCollection'
import { IconSearch } from '@ds/icons/IconSearch'

const props = defineProps<{
  entryType: 'search-query' | 'plp'
  title: string
}>()

const icon = computed(() => {
  if (props.entryType === 'search-query') return IconSearch

  if (props.entryType === 'plp') return IconProductCollection

  return null
})

const label = computed(() => {
  if (props.entryType === 'search-query') return `"${props.title}"`

  return props.title
})
</script>
